import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

//icons
import { IconErrorBig } from "../../../Icons/icons";

//hooks
import usePageError from "../../../hooks/usePageError";

//MUI components
import Button from "@mui/material/Button";

//styles
import { bgHeaders } from "../../../styles/theme";

interface Props {
  inPage?: boolean;
  externalRetryFn?: () => void;
  externalCancelFn?: () => void;
}

const PageErrorWrapper = styled.div`
  max-width: 100%;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  background: rgba(227, 227, 227, 0.8);

  &.in-page {
    position: relative;
    background: transparent;
    min-height: 0;
    height: 100%;

    .content {
      box-shadow: none;
    }
  }

  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-height: 90%;
    max-width: calc(130 * var(--atom));
    background: ${bgHeaders};
    border-radius: calc(1.6 * var(--atom));
    padding: calc(9.6 * var(--atom));
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  }

  .msg-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .title-big {
    font-size: calc(5.6 * var(--atom));
    line-height: calc(6.2 * var(--atom));
    margin-top: calc(3 * var(--atom));
  }

  .msg-text {
    font-size: calc(3.6 * var(--atom));
    line-height: calc(5.2 * var(--atom));
    margin-top: calc(4 * var(--atom));
  }

  .btns-wrapper {
    display: flex;
    margin-top: calc(4 * var(--atom));
    justify-content: center;
    button {
      width: auto;
      margin: 0 calc(2 * var(--atom));
    }
  }
`;

const PageError: React.FC<Props> = ({ inPage, externalRetryFn, externalCancelFn }) => {
  const { t } = useTranslation();
  const { errorMsg, setVisibleError, setErrorMsg, retryFn } = usePageError();
  return (
    <PageErrorWrapper className={inPage ? "in-page" : ""}>
      <div className="content">
        <div className="msg-wrapper">
          <IconErrorBig />
          <span className="title-big">{t("common.errorOccured")}</span>
          {errorMsg && <span className="msg-text">{errorMsg}</span>}
        </div>
        <div className="btns-wrapper">
          <Button
            variant="contained"
            color="primary"
            type="submit"
            size="large"
            onClick={() => {
              if (externalRetryFn) {
                return externalRetryFn();
              }
              setVisibleError(false);
              if (typeof retryFn.execute === "function") {
                retryFn.execute();
              }
            }}
          >
            {t("common.tryAgain")}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            type="submit"
            size="large"
            onClick={() => {
              if (externalCancelFn) {
                return externalCancelFn();
              }
              setVisibleError(false);
              setErrorMsg("");
            }}
          >
            {t(`common.${externalCancelFn ? "back" : "close"}`)}
          </Button>
        </div>
      </div>
    </PageErrorWrapper>
  );
};

export default PageError;
